import { useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
export var useUserTable = function (onRowClick) {
    var formatMessage = useIntl().formatMessage;
    var handleFirstNameClick = useCallback(function (item) {
        onRowClick(item);
    }, [onRowClick]);
    var isUserAdmin = function (user) {
        var _a, _b;
        return (_b = (_a = user.libraries) === null || _a === void 0 ? void 0 : _a.some(function (lib) { return lib.isAdmin; })) !== null && _b !== void 0 ? _b : false;
    };
    var getLibraryNames = function (user) {
        if (!user.libraries || user.libraries.length === 0) {
            return "-";
        }
        return user.libraries.map(function (lib) { var _a, _b; return (_b = (_a = lib.library) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ""; }).join(", ");
    };
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.users.table.name",
            }),
            key: "firstName",
            alwaysVisible: true,
            clickable: true,
            onClick: handleFirstNameClick,
            cellRenderer: function (item) {
                return "".concat(item.firstName || "", " ").concat(item.lastName || "").trim() || "-";
            },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.users.table.email",
            }),
            key: "email",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.users.table.role",
            }),
            key: "role",
            cellRenderer: function (item) {
                return isUserAdmin(item)
                    ? formatMessage({ id: "ui-br-legaldeposits.userRole.admin" })
                    : formatMessage({ id: "ui-br-legaldeposits.userRole.librarian" });
            },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.users.table.library",
            }),
            key: "libraries",
            cellRenderer: function (item) { return getLibraryNames(item); },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.users.field.status",
            }),
            key: "status",
            cellRenderer: function (item) {
                var _a;
                return formatMessage({
                    id: "ui-br-legaldeposits.userStatus.".concat(((_a = item.status) !== null && _a !== void 0 ? _a : "ACTIVE").toLowerCase()),
                });
            },
        },
    ]; }, [formatMessage, handleFirstNameClick]);
    return {
        columns: columns,
    };
};
